/* Componente interno al drawer per la creazione del calcolo del percorso */

import React from 'react';
import CalcoloPercorso from '../CalcoloPercorso'
import calcoloPercorsoImage from './Calcolodelpercorso.svg'
import CloseIcon from '@material-ui/icons/Close';
import './SelectPathComponent.css'
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
export default function SelectPathComponent(props) {
  useTranslation();
  //  const {t} = useTranslation();
  //const [lunghezza, setLunghezza] = React.useState(345)
  const [lunghezza, setLunghezza] = React.useState(395) //React.useState(415)
  
  const setDiv = (status) => {
    //status ? setLunghezza(350) : setLunghezza(280)
    status ? setLunghezza(415) : setLunghezza(345)
    
  }
  const setClose =  () => {props.callback()}

  return (
        <div className={"lateraltDiv"} id={"drawer_id"}>
          <div className={"title"}>
            <img src={calcoloPercorsoImage} alt="Calcolo" className={"calcoloPercorsoImage"}></img><Trans>Calcolo Percorso</Trans> <button className={"buttonClose"} onClick={props.callback}><CloseIcon/></button></div>
            
        <div className={"percorsoDiv"} style={{height: lunghezza}} >
          <CalcoloPercorso callback={setDiv.bind(this)} closeButton={setClose.bind(this)} parameters={props.parameters} search={props.search} httpProxy={props.httpProxy}/>
        </div>
        </div>

  );
}